import { render, staticRenderFns } from "./SolutionsTeam.vue?vue&type=template&id=f51713dc&scoped=true"
import script from "./SolutionsTeam.js?vue&type=script&lang=js&external"
export * from "./SolutionsTeam.js?vue&type=script&lang=js&external"
import style0 from "./SolutionsTeam.scss?vue&type=style&index=0&id=f51713dc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51713dc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default})
